<template>
  <div id="app" :style="{ 'max-width': width + 'px' }">
    <header>
      <div class="content-wrapper">
        <span class="logo-wrapper">
          <img src="../assets/layout/hengitysliitto_logo.png" />
        </span>

        <span id="korjausarvio-logo" class="logo-wrapper">
          <img src="../assets/layout/korjausarvio_logo.png" />
        </span>

        <div class="expander"></div>
      </div>
    </header>

    <main>
      <slot>
        MAIN CONTENT HERE
      </slot>
    </main>

    <footer>
      <div class="content-wrapper">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-3">
              <a target="_blank" href="https://hometalkoot.fi">
                <img style="width: 200px; max-width: 100%;" src="../assets/hometalkoot-logo.gif" />
              </a>
              <br />
              <br />
              <br />
            </div>
            <div class="col-md-6">
              <p>Korjausten kustannusarviotyökalun sisällön ylläpidosta vastaa Hengitysliitto.</p>
              <p>
                Palvelun tarjoaa yhteistyössä:
                <a target="_blank" href="http://www.hengitysliitto.fi">Hengitysliitto</a> ja
                <a target="_blank" href="https://www.talopeli.fi">TaloPeli</a> -
                <a target="_blank" href="http://www.viscom.fi">Visual computing Oy.</a>
              </p>
              <p>Kaikki oikeudet pidätetään.</p>
              <p v-if="currentUser.authenticated">
                {{ currentUser.username }}
                (<a href="/laskuri/logout">{{ 'layout.logout' | i18n }}</a>)
              </p>
              <p v-else>
                <a href="/laskuri/login">{{ 'layout.login' | i18n }}</a>
              </p>
              <br />
            </div>
            <div class="col-md-3">
              <strong>Muista myös:</strong><br />
              <a target="_blank" href="http://www.hengitysliitto.fi">hengitysliitto.fi</a><br />
              <a target="_blank" href="https://hometalkoot.fi">hometalkoot.fi</a>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      width: {
        type: Number,
        default: 1540
      }
    },
    computed: {
      ...mapGetters('user', [
        'currentUser'
      ])
    }
  }
</script>

<style scoped>
  .logo-wrapper {
    display: inline-block;
    vertical-align: middle;
    line-height: 100px;
    max-width: 49%;
  }

  .logo-wrapper img {
    max-width: 100%;
  }

  #korjausarvio-logo {
    float: right;
  }

  #app {
    min-width: 360px;
    max-width: 1540px;
    margin: auto;
    overflow: hidden;
  }

  footer {
    color: gray;
    font-size: small;
    /*text-align: center;*/
    background-image: url('../assets/layout/footer-bg.png');
    background-repeat: repeat-x;
    min-height: 215px;
    padding-top: 40px;
  }

  footer a,
  footer a:link,
  footer a:visited,
  footer a:hover,
  footer a:active {
    color: gray;
    text-decoration: underline;
  }

  header {
    background-color: #f4f4f4;
  }

  header .expander {
    display: inline-block;
    width: 1px;
    height: 100px;
    vertical-align: middle;
  }

  header:after {
    content: "";
    display: table;
    clear: both;
  }
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue